import i18next, { i18n, LanguageDetectorAsyncModule } from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-xhr-backend';

import { languages } from 'languages';
import { Country, DE_LOCALE_COUNTRIES, REACT_APP_API_URL } from 'helpers/conf';

export const availableLng = Object.keys(languages).reduce((acc, keyLoc) => {
  return acc.concat(languages[keyLoc].map((locale) => locale.locale));
}, [] as string[]);

export const fallbackLng = 'en';

const lookupItemName = 'lng';

let i18nInstance: i18n;

const I18nInstanceSetter = {
  type: '3rdParty' as const,

  init(instance: i18n) {
    i18nInstance = instance;
  },
};

export { i18nInstance };

const CustomLanguageDetector: LanguageDetectorAsyncModule = {
  type: 'languageDetector' as const,
  async: true,
  init: function () {},
  detect: function (callback: (lng: string) => void): void {
    const languageFromLocalStorage = localStorage.getItem(lookupItemName);

    if (
      languageFromLocalStorage != null &&
      languageFromLocalStorage !== '' &&
      availableLng.some((lang) => lang === languageFromLocalStorage)
    ) {
      return callback(languageFromLocalStorage);
    }

    const domain =
      window.appConfig.APP_ENV === 'development' ? '' : REACT_APP_API_URL;

    fetch(`${domain}/api/current_ip`)
      .then((res) => res.json())
      .then(({ country_code, ...rest }) => {
        return {
          ...rest,
          country_code: DE_LOCALE_COUNTRIES.includes(country_code)
            ? Country.Germany
            : country_code,
        };
      })
      .then((data) => {
        localStorage.setItem('country_code', data.country_code);
        return data;
      })
      .then((data) => {
        const { country_code } = data as {
          ip: string;
          country_code: string;
          region_code: string;
        };

        const currentLanguage =
          languages[country_code]?.find(
            ({ locale }) => locale === navigator.language
          ) ||
          languages[country_code]?.[0] ||
          languages[Country.UnitedKingdom][0];

        return callback(currentLanguage.locale);
      })
      .catch((error) => {
        return callback(fallbackLng);
      });
  },
  cacheUserLanguage: function (lng: string) {
    localStorage.setItem(lookupItemName, lng);
  },
};

i18next.on('languageChanged', (lng) => {});

i18next.on('initialized', function () {
  console.log('Localization was initialized');
});

i18next.on('failedLoading', function (lng, ns, msg) {});

export default i18next
  .use(CustomLanguageDetector)
  .use(XHR)
  .use(I18nInstanceSetter)
  .use(initReactI18next)
  .init({
    whitelist: availableLng,
    fallbackLng: fallbackLng,
    load: 'currentOnly',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: lookupItemName,
    },
    ns: [
      'glossary',
      'common',
      'validation',
      'deposits',
      'adventMission',
      'jackpot',
      'mobileApp',
      'emailNDBModal',
      'promotions',
    ],
    defaultNS: 'common',
    debug: window.appConfig.APP_ENV !== 'production',
    react: { useSuspense: false },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
